<div class="time-scroller">
  <div class="time-scroller-icon">
    <img src="assets/svg/time-outline.svg" class="clock-icon" />
  </div>
  @if (showLeftArrow) {
    <div class="scroller-arrow scroller-arrow-left" (click)="scrollLeft()">
      <img src="assets/svg/chevron-back-outline.svg" class="scroller-arrow-icon" />
    </div>
  }
  <div class="time-scroller-track" #track (scroll)="onScroll()">
    @for (item of times; track trackByValue($index, item)) {
      <div
        class="time-cell"
        [class.time-cell-selected]="isInRange(item.value)"
        (click)="selectTime(item)">
        <span class="time-label">{{ item.display }}</span>
      </div>
    }
  </div>
  @if (showRightArrow) {
    <div class="scroller-arrow scroller-arrow-right" (click)="scrollRight()">
      <img src="assets/svg/chevron-forward-outline.svg" class="scroller-arrow-icon" />
    </div>
  }
</div>
